import type { CoverSheetConfigCard } from '../../types';
import {
  compliancePropertyToggleFields,
  compliancePropertyTogglesLayoutRow,
} from './complianceUpstreamFields';

export const propertyDetailsCard = {
  id: 'propertyInfo.propertyDetails',
  innerTitle: 'Property Details',
  layout: [
    [
      {
        name: 'property.bedrooms',
        size: 25,
        mobileSize: 50,
      },
      {
        name: 'property.bathrooms',
        size: 25,
        mobileSize: 50,
      },
      {
        name: 'property.buildingArea',
        size: 25,
        mobileSize: 50,
      },
      {
        name: 'property.lotSize',
        size: 25,
        mobileSize: 50,
      },
    ],
    compliancePropertyTogglesLayoutRow,
    [
      {
        name: 'insideListingDescription',
        size: 100,
      },
    ],
  ],
  fields: {
    bedrooms: {
      name: 'property.bedrooms',
      entity: 'property',
      type: 'integer',
      label: 'Beds',
      placeholderText: '',
    },
    bathrooms: {
      name: 'property.bathrooms',
      entity: 'property',
      type: 'number',
      label: 'Baths',
      placeholderText: '',
    },
    buildingArea: {
      name: 'property.buildingArea',
      entity: 'property',
      type: 'number',
      label: 'Square Footage',
      placeholderText: '',
    },
    lotSize: {
      name: 'property.lotSize',
      entity: 'property',
      type: 'number',
      label: 'Lot Size',
      placeholderText: '',
    },
    insideListingDescription: {
      name: 'insideListingDescription',
      entity: 'interaction',
      type: 'textarea',
      label: 'Description',
      placeholderText: '',
    },
    ...compliancePropertyToggleFields,
  },
} satisfies CoverSheetConfigCard;
